import { Link } from 'react-scroll';
import './BannerCommericial.css';

const BannerCommericial = ()=>{
    return(
        <>
        <div className="breadMain">
            <div className="container">
                  <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                          <li className="breadcrumb-item"><a href="/rentshield">rentshield</a></li>
                          <img className="" src="/img/arrow-right-nav.svg" alt="arrow"/>
                          <li className="breadcrumb-item active" aria-current="page">Commercial Auto Insurance & Protection</li>
                      </ol>
                  </nav>
            </div>
        </div>
        {/* START bannerCommericialMain */}
              <section className="bannerCommericialMain">
                <div className="container">
                  <div className="bannerCommericialOuter">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                          <div className="bannerCommericialLeft">
                            <img className="img-fluid" src="/img/rentshield/shield_banner.webp" alt="banner"/>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="bannerCommericialRight">
                            <small>COMMERCIAL AUTO INSURANCE & PROTECTION</small>
                            <h2>Direct rental, Primary, Commercial Auto Insurance, <span>billed per day.</span></h2>
                            <p>Protect revenue-generating assets for personal and gig-economy rentals.</p>
                            <ul>
                                <li><Link to="onRentMain" smooth={true} duration={1000} offset={-10} spy={true}>
                                  On-Rent Coverage
                                </Link></li>
                                <li><Link to="offRentInsuranceMain" smooth={true} duration={1000} offset={-10} spy={true}>
                                Off-Rent Coverage
                                </Link></li>
                                <li><Link to="PersonalRental" smooth={true} duration={1000} offset={-10} spy={true}>
                                Personal Rental
                                </Link></li>
                                <li><Link to="GigRental" smooth={true} duration={1000} offset={-10} spy={true}>
                                Gig Rental
                                </Link></li>
                            </ul>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </section>
        {/* END bannerCommericialMain */}

        </>
    )
}

export default BannerCommericial;